// ContactsTable.tsx
import { Contact } from "@/lib/vibrato-api"
import { ColDef } from "ag-grid-community"
import "ag-grid-community/styles/ag-grid.css"
import "ag-grid-community/styles/ag-theme-quartz.css"
import { AgGridReact } from "ag-grid-react"
import { Button } from "flowbite-react"
import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community"

ModuleRegistry.registerModules([AllCommunityModule])

export default function ContactsTable({
  vibratoClient,
  reloadCounter,
  setSelectedContacts,
  openCreateTaskTemplateCallModal,
  queryOptions,
  showCreateCall,
  showValidationErrors,
  campaignUuid,
  showInvalid
}: any) {
  const navigate = useNavigate()
  const gridRef = useRef<AgGridReact>(null)
  const [contacts, setContacts] = useState<Array<Contact>>([])

  const columnDefs: ColDef[] = [
    {
      headerName: "First Name",
      field: "first_name",
      filter: true,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      checkboxSelection: true,
      flex: 1
    },
    { headerName: "Last Name", field: "last_name", filter: true, flex: 1 },
    // { headerName: "Country Code", field: "country_code", filter: true },
    { headerName: "Phone Number", field: "phone_number", filter: true, flex: 1 },
    // { headerName: "Tags", field: "tags", filter: true, valueFormatter: (params) => params.value.join(", ") },
    {
      headerName: "",
      field: "tools",
      width: 180,
      flex: 1,
      cellRenderer: (props: any) => {
        let currentCampaignCall: any = null
        props.data?.current_campaign_calls?.forEach((call: any) => {
          if (call.campaign_uuid === campaignUuid) {
            currentCampaignCall = call
          }
        })

        return (
          <div className="w-full h-full flex justify-end items-center gap-2">
            {showValidationErrors && currentCampaignCall && currentCampaignCall?.validation_error && (
              <span className="bg-red-100 text-red-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-full dark:bg-red-900 dark:text-red-300 w-max">
                Invalid
              </span>
            )}
            <div className="w-min h-min flex items-center">
              <Button
                size="xs"
                pill
                color="light"
                onClick={() => {
                  navigate(`/contacts/${props.data.uuid}`)
                }}
              >
                View
              </Button>
            </div>
            {showCreateCall && (
              <div className="w-min h-min flex items-center">
                <Button
                  size="xs"
                  pill
                  color="blue"
                  onClick={() => {
                    openCreateTaskTemplateCallModal(props.data)
                  }}
                >
                  Create Call
                </Button>
              </div>
            )}
          </div>
        )
      }
    }
  ]

  useEffect(() => {
    const loadAllContacts = async (options: any = {}) => {
      let allContacts: Array<Contact> = []
      let pageLink: string | null = null

      do {
        const response: any = await vibratoClient.getContacts({
          ...options,
          pageLink: pageLink,
          showInvalid: showInvalid
        })

        allContacts = [...allContacts, ...response.results]
        pageLink = response.next // Assuming the paginated response has a 'next' field with the next page URL
      } while (pageLink)

      return allContacts
    }

    const options = queryOptions || {}

    loadAllContacts(options).then((contacts: Array<Contact>) => {
      setContacts(contacts)
    })
  }, [reloadCounter, showInvalid])

  const onSelectionChanged = (event: any) => {
    const selectedRows = event.api.getSelectedRows()
    if (selectedRows.length > 0) {
      setSelectedContacts(selectedRows)
    } else {
      setSelectedContacts([])
    }
  }

  return (
    <div
      // className="ag-theme-quartz"
      style={{
        height: "100%"
      }}
      className="ag-theme-quartz w-full min-w-[800px]"
    >
      <AgGridReact
        columnDefs={columnDefs}
        // @ts-ignore
        theme="quartz"
        ref={gridRef}
        rowData={contacts}
        pagination
        paginationPageSize={100}
        paginationPageSizeSelector={[100, 200, 500]}
        rowSelection="multiple"
        onSelectionChanged={onSelectionChanged}
        paginationAutoPageSize
      />
    </div>
  )
}
